module.exports = __webpack_public_path__ + "static/media/fanzhh_wechat_shoukuan.c77d8f53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fanzhh_wechat_shoukuan.jpg
// module id = 673
// module chunks = 0